import React from "react";
import LegalNotices from "../../components/LegalNotices/LegalNotices";
import StyledLgText from "../../common/components/styledLgText/StyledLgText";
import StyledH4Heading from "../../common/components/styledH4Heading/StyledH4Heading";
import useScrollToTop from "../../utils/useScrollToTop";

const TermsNConditionsPage = () => {
  useScrollToTop()
  return (
    <LegalNotices
      heading="Terms & Conditions"
      content={
        <div className="space-y-3">
          <StyledH4Heading>
            The Standard Lorem Ipsum Passage, Used Since The 1500s
          </StyledH4Heading>
          <StyledLgText fontColor={"font-light"}>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries, but also the leap into electronic typesetting,
            remaining essentially unchanged. It was popularised in the 1960s
            with the release of Letraset sheets containing Lorem Ipsum passages,
            and more recently with desktop publishing software like Aldus
            PageMaker including versions of Lorem Ipsum. <br /> Why do we use
            it? <br /> It is a long established fact that a reader will be
            distracted by the readable content of a page when looking at its
            layout. The point of using Lorem Ipsum is that it has a more-or-less
            normal distribution of letters, as opposed to using 'Content here,
            content here', making it look like readable English. Many desktop
            publishing packages and web page editors now use Lorem Ipsum as
            their default model text, and a search for 'lorem ipsum' will
            uncover many web sites still in their infancy. Various versions have
            evolved over the years, sometimes by accident, sometimes on purpose
            (injected humour and the like).
          </StyledLgText>
        </div>
      }
    />
  );
};

export default TermsNConditionsPage;
